import { render } from "./ParticipantDrugTestReport.vue?vue&type=template&id=386cb5da&ts=true"
import script from "./ParticipantDrugTestReport.vue?vue&type=script&lang=ts"
export * from "./ParticipantDrugTestReport.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__